import { err, ok } from '@easeltv/fail';

import { ResponseParseFail } from '../errors';

/**
 * parseArrayBuffer
 *
 * parse the ArrayBuffer from the request Response
 *
 * @param response - fetch Response object
 */
export const parseArrayBuffer = async (response: Response) => {
    try {
        const body = await response.arrayBuffer();

        return ok({
            status: response.status,
            body,
        });
    } catch (error) {
        return err(
            new ResponseParseFail({
                name: 'Response Parse Error',
                description: 'Could not get array buffer from response',
                key: 'remote.parse.buffer',
                data: { error, response },
                status: response.status,
            }),
        );
    }
};
